import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

type UseSyncUrlParamToStoreOptions<T extends string> = {
  paramKey: string;
  validValues: readonly T[];
  setStoreValue: (value: T) => void;
};

/**
 * Syncs a URL search param to a store value on mount.
 * Validates the param value against a list of valid values before setting.
 */
export const useSyncUrlParamToStore = <T extends string>({
  paramKey,
  validValues,
  setStoreValue
}: UseSyncUrlParamToStoreOptions<T>) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const paramValue = searchParams.get(paramKey);
    if (paramValue && validValues.includes(paramValue as T)) {
      setStoreValue(paramValue as T);
    }
  }, []);
};
